import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <defs>
      <path
        id="icons-twitter_svg__a"
        d="M8.659 19.619c6.796 0 10.513-5.863 10.513-10.947 0-.167 0-.333-.011-.498a7.698 7.698 0 001.843-1.991 7.148 7.148 0 01-2.122.605 3.838 3.838 0 001.625-2.128 7.229 7.229 0 01-2.347.934c-1.145-1.268-2.965-1.579-4.439-.757-1.474.821-2.235 2.57-1.857 4.266-2.97-.155-5.739-1.616-7.615-4.02-.98 1.758-.48 4.007 1.144 5.136a3.557 3.557 0 01-1.677-.481v.048c0 1.832 1.24 3.41 2.964 3.772a3.547 3.547 0 01-1.668.066c.484 1.567 1.871 2.641 3.452 2.672a7.229 7.229 0 01-4.589 1.65c-.294 0-.587-.019-.88-.055a10.16 10.16 0 005.664 1.725"
      />
    </defs>
    <use
      fill="currentColor"
      fillRule="evenodd"
      xlinkHref="#icons-twitter_svg__a"
    />
  </svg>
);
